
import { Component, OnInit, Input, ViewChildren, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css']
})
export class ModuleComponent implements OnInit {

  @Input() module: any;
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked = new EventEmitter<any>();
  // @ViewChild('moduleTile') moduleTile: ElementRef;
  // @ViewChild('moduleTileImg') moduleTileImg: ElementRef;
  @ViewChild('infoToggle') infoToggle :ElementRef;
  
  url='../moduledetails';
  routerParams;
  //livemeetinglink: string = '';
  userjwt: string = ''
  environment;
  //hasliveclass: any;
  constructor(private router: Router, private useraccessservice: UseraccessserviceService, private moduleservice: ModulemanagementService) {
    this.environment = environment;
    this.userjwt = this.useraccessservice.getCurrentUserToken();
  }

  detailsHeader="";
  detailsLessonCount="";
  detailsDescription="";

  
   
  async ngOnInit() {
    //debugger;
    //console.log(this.currentUserIsAdmin);
    this.routerParams = { moduleID: this.module.id };
    // this.hasliveclass = this.module.hasLiveClass;
    // this.livemeetinglink = `${environment.ImpataAppAPIRoot}moduleclass/nextliveclass?userjwt=${this.userjwt}&moduleid=${this.module.id}`;
  }


  deleteClickedFired(module){
    //debugger;
    this.deleteClicked.emit(module);
  }


  // setSize(tileWidth, imageWidth, imageHeight) {
  //   $(this.moduleTile.nativeElement).width(tileWidth);
  //   $(this.moduleTileImg.nativeElement).width(imageWidth);
  //   $(this.moduleTileImg.nativeElement).height(imageHeight);
  // }

 
}
